const fonts = {
  default: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
};

const fontSizes = {
  small: 12,
  medium: 14,
  regular: 16,
  large: 20,
  xlarge: 32,
};

export { fontSizes, fonts };

